/* eslint-disable @typescript-eslint/naming-convention */
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
@Component({
  selector: 'delete-parts-confirmation.component',
  templateUrl: './delete-parts-confirmation.component.html',
  styleUrls: ['./delete-parts-confirmation.component.scss']
})
export class DeletePartsConfirmationComponent implements OnInit {
  updateAllRecurringJobForm = new UntypedFormGroup({
    update_all_jobs : new UntypedFormControl(false)
  });
  dialogData: any;
  showButtonSpinner: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<DeletePartsConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any){}


  ngOnInit(): void {
    this.dialogData = this.data.data;
  }

  submit(): void{
   this.dialogRef.close(this.updateAllRecurringJobForm?.value);
  }

}


